var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgDoneIcon = function SvgDoneIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 0C17.4562 0 0 17.4562 0 39C0 60.5438 17.4562 78 39 78C60.5438 78 78 60.5438 78 39C78 17.4562 60.5438 0 39 0ZM58.9688 28.2188L33.9 53.4H33.8812C33.5625 53.7187 32.7 54.4312 31.7063 54.4312C30.9938 54.4312 30.1875 54.0375 29.5125 53.3625L19.0125 42.8625C18.7125 42.5625 18.7125 42.0938 19.0125 41.7937L22.35 38.4563C22.5 38.3063 22.6875 38.2312 22.875 38.2312C23.0625 38.2312 23.25 38.3063 23.4 38.4563L31.725 46.7812L54.6 23.7375C54.75 23.5875 54.9375 23.5125 55.125 23.5125C55.3312 23.5125 55.5187 23.5875 55.65 23.7375L58.9312 27.1312C59.2687 27.45 59.2687 27.9188 58.9688 28.2188Z",
    fill: "#7CDA98"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgDoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/done_icon.4413bfee4d64c318dd88d1e1a88d4bce.svg";